import React, { Component } from 'react';
import { Panel, ControlLabel, Glyphicon } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import API_URL from './../../constants/server';
import axios from 'axios';
import ProfileWrapper from './style.js';
class Profile extends Component {
  componentWillMount() {
    this.setState({ profile: {} });
    const { userProfile, getProfile } = this.props.auth;
    if (!userProfile) {
      getProfile((err, profile) => {
        this.setState({ profile });
      });
    } else {
      this.setState({ profile: userProfile });
    }
  }

  componentDidMount(){

    const { getAccessToken } = this.props.auth;
    const headers = { 'Authorization': `Bearer ${getAccessToken()}`}
    axios.get(`${API_URL}/user/campaigns`, { headers } )
    .then((response)=>{
      // const raw_data = response.data;
      // console.log(response.data);
      
      const campaignList = response.data;
      this.setState(
        { campaignList }
      )
    })
  }

  render() {
    const { profile, campaignList } = this.state;
    console.log ( this.state.campaignList)
    let content = (<div></div>);
    // If we have budgetSplit, render them
    if (campaignList) {
      content = campaignList.map((item) => {
        console.log ( item)

        if ( item && item.searchAdsIds.length > 0){
          console.log ( item.searchAdsIds)

          return (
            <section> 
              <div> App Name Ref:{ item.startTime}</div>
            {
                item.searchAdsIds.map((campaignID) => {
                return (
                <div>
                  <Link key={campaignID} to={`/campaign/${campaignID}`}>Go to campaign Detail : {campaignID}</Link>
                </div>
                )
              })
            }
            </section>
          );
        } else if ( item && item.searchAdsCampaign){
          const campaignID = item.searchAdsCampaign
          console.log ( campaignID)

          return (
            <div>
              <Link key={campaignID} to={`/campaign/${campaignID}`}>Go to campaign Detail : {campaignID}</Link>
            </div>
          )
        } else {
          return <div>dd</div>;
        }
      });

    } 


    return (
      <div className="container">
        <div className="profile-area">
          <h1>{profile.name}</h1>
          <Panel header="Profile">
            <img src={profile.picture} alt="profile" />
            <div>
              <ControlLabel><Glyphicon glyph="user" /> Nickname</ControlLabel>
              <h3>{profile.nickname}</h3>
            </div>
            <pre>{JSON.stringify(profile, null, 2)}</pre>
          </Panel>

          <Panel header="Campaign">
            <div>
             { content }
            </div>
          </Panel>
        </div>
          
      </div>
    );
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./src/containers/Profile/index.js